// extracted by css-extract-rspack-plugin
export default {"ModalExternalLink":"S3nBx","code":"En8Ct","copyButton":"UzSkD"};